import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";

interface SkillCategory {
  label: string;
  icon: string;
  skills: string[];
  color: string;
  bgColor: string;
}

const categories: SkillCategory[] = [
  {
    label: "Backend",
    icon: "⚙️",
    skills: ["Python", "PHP", "Rust", "Flask", "FastAPI", "Laravel"],
    color: "#1E40AF",
    bgColor: "#EFF6FF",
  },
  {
    label: "Frontend",
    icon: "🖥️",
    skills: ["JavaScript", "TypeScript", "Vue.js", "React.js", "Nuxt.js"],
    color: "#065F46",
    bgColor: "#ECFDF5",
  },
  {
    label: "Infra / Others",
    icon: "☁️",
    skills: [
      "AWS",
      "Azure",
      "Docker",
      "Nginx",
      "MySQL",
      "PostgreSQL",
      "Terraform",
      "SAM",
    ],
    color: "#7C3AED",
    bgColor: "#F5F3FF",
  },
];

export default function SkillSet() {
  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      sx={{ maxWidth: 900, mx: "auto" }}
    >
      {categories.map((cat) => (
        <Grid item xs={12} sm={6} md={4} key={cat.label}>
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #E2E8F0",
              borderRadius: 3,
              p: 3,
              height: "100%",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              transition: "box-shadow 0.2s ease",
              "&:hover": {
                boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <Typography fontSize="1.3rem">{cat.icon}</Typography>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "#0F172A", fontSize: "1rem" }}
              >
                {cat.label}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {cat.skills.map((skill) => (
                <Chip
                  key={skill}
                  label={skill}
                  size="small"
                  sx={{
                    backgroundColor: cat.bgColor,
                    color: cat.color,
                    fontWeight: 500,
                    border: "none",
                    fontSize: "0.78rem",
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
